import {ReactNode} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons'
import {createUseStyles} from 'react-jss'
import {Colors} from '../constants/colors'

export type DetailValueSeverity = 'warning' | 'danger'

interface Props {
  label: string
  value: ReactNode
  severity?: DetailValueSeverity
  tooltip?: string
}

const DetailValueRow = ({label, value, severity, tooltip}: Props) => {
  const styles = useStyles()

  return (
    <p>
      {label}: <span>{value}</span>
      {severity &&
          <span className={styles.marker} title={tooltip}>
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              color={severity === 'danger' ? Colors.yuan_600 : Colors.yen_600}
            />
          </span>
      }
    </p>
  )
}

export default DetailValueRow

const useStyles = createUseStyles({
  marker: {
    display: 'inline-block',
    marginLeft: 6,
    verticalAlign: 'baseline'
  }
})
